import Swiper from 'swiper/bundle';
import { A11y, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    new Swiper(".slide-text-swiper", {
        modules: [A11y, Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletElement: 'button',
            renderBullet: function (index, className) {
                return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            disabledClass: 'opacity-50 cursor-not-allowed',
        },
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification',
            containerMessage: 'Text slider',
            containerRoleDescriptionMessage: 'carousel',
            itemRoleDescriptionMessage: 'slide',
        },
    });
});
